import gql from 'graphql-tag';

const GET_PROJECT = gql`
  query project($where: ProjectWhereUniqueInput!) {
    project(where: $where) {
      id
      name
      description
      status
      priority
      startDate
      endDate
      createdAt
      updatedAt
      owner {
        id
        name
        username
        avatar {
          id
          key
        }
        roles {
          id
          org {
            id
            level
            parentOrg {
              id
            }
          }
        }
      }
      team {
        id
        name
        username
        avatar {
          id
          key
        }
      }
      tasks {
        id
        name
        status
        startDate
        dueDate
        createdAt
        urgency
        requestType
        assigneeUsers {
          id
          name
          username
          avatar {
            id
            key
          }
        }
        channelPartner {
          id
          name
        }
        advertiser {
          id
          name
        }
      }
    }
  }
`;

export default GET_PROJECT;
